import { useEffect } from 'react'
import microApp, { getActiveApps } from '@micro-zoe/micro-app'
import useRouter from './router'
import { useAppStore } from '@/stores'

/**
 * App
 */
const App = () => {
  const element = useRouter()
  const { setActivePaths, setLayoutOptions } = useAppStore()

  // 全局数据
  const { org = {} } = (microApp.getGlobalData() || {}) as any
  const { apps = [] } = org

  useEffect(() => {
    if (apps.length <= 0) return

    const preFetchApps = []

    for (const app of apps) {
      if (app.isMain) continue
      // 未激活的应用，进行预加载资源
      if (!getActiveApps().includes(app.code)) {
        preFetchApps.push({ name: app.code, url: app.url, level: 2 })
      }

      // 监听应用消息
      microApp.addDataListener(
        app.code,
        (data: any) => {
          if (!data) return

          if (data.layoutOptions) {
            setLayoutOptions({
              ...data.layoutOptions
            })
          }

          if (data.matches) {
            const { handle } = data.matches.pop()
            if (!handle || !handle.code) return

            setActivePaths(handle.code)
          }
        },
        true
      )
    }

    // 预加载资源
    microApp.preFetch(preFetchApps)

    return () => {
      for (const app of apps) {
        if (app.isMain) continue
        microApp.clearDataListener(app.code)
      }
    }
  }, [apps])

  return element
}

export default App
